import Notification from './service/notification';
import UserNotification from './service/user-notification';

export default {
  Notification,
  UserNotification
};
